module.exports = __webpack_public_path__ + "img/img-a18bb9bf.c2833544.png";